import { useMutation, useQuery, useQueryClient } from "react-query";
import clientApi from "./client";
import {
  accountBanks,
  accountBVN,
  accountKYC,
  accountPassword,
  accountPin,
  accountProfile,
  bankAccount,
  deleteCard,
} from "./routes";

// ---------- ACCOUNT GET PROFILE -----------

export const getUsersProfile = async () => {
  const { data } = await clientApi.get(accountProfile);
  return data.data;
};

// ---------- ACCOUNT CHANGE PIN -----------

const usersPin = (data) => {
  return clientApi.post(accountPin, data);
};

export const useHandlePin = (setConfirmModal, setErrorModal) => {
  return useMutation(usersPin, {
    onSuccess: () => {
      setConfirmModal(true);
    },
    onError: () => {
      setErrorModal(true);
    },
  });
};

// ---------- ACCOUNT CHANGE PASSWORD -----------

const usersPasswordChange = (data) => {
  console.log("PASSWORD ", data);

  return clientApi.post(accountPassword, data);
};

export const usePasswordChangeHandler = (setConfirmModal, setErrorModal) => {
  return useMutation(usersPasswordChange, {
    onSuccess: () => {
      setConfirmModal(true);
    },
    onError: () => {
      setErrorModal(true);
    },
  });
};

// ---------- ACCOUNT GET PROFILE -----------

const fetchUserBank = async () => {
  const { data } = await clientApi.get(accountBanks);
  return data;
};

export const useGetUsersBank = () => {
  return useQuery("bank-list", fetchUserBank);
};

// ---------- ACCOUNT POST KYC -----------

const usersKYC = (data) => {
  return clientApi.post(accountKYC, data);
};

export const useKYChandler = (setConfirmModal, setErrorModal) => {
  return useMutation(usersKYC, {
    onSuccess: () => {
      setConfirmModal(true);
    },
    onError: () => {
      setErrorModal(true);
    },
  });
};

// ---------- ACCOUNT GET KYC -----------

const getUsersKYC = async () => {
  const { data } = await clientApi.get(accountKYC);
  return data;
};

export const useGetUsersKYC = () => {
  return useQuery("users-kyc", getUsersKYC);
};

// ---------- ACCOUNT POST BVN -----------

const usersBVN = (data) => {
  return clientApi.post(accountBVN, data);
};

export const useBVNhandler = (setConfirmModal, setErrorModal) => {
  return useMutation(usersBVN, {
    onSuccess: () => {
      setConfirmModal(true);
    },
    onError: () => {
      setErrorModal(true);
    },
  });
};

// ---------- ACCOUNT GET BVN -----------

const getUsersBVN = async () => {
  const { data } = await clientApi.get(accountBVN);
  return data;
};

export const useGetUsersBVN = () => {
  return useQuery("users-BVN", getUsersBVN);
};

// ---------- ADD BANK ACCOUNT -----------

const handleBankAccount = (data) => {
  return clientApi.post(bankAccount, data);
};

export const useBankAccount = (setConfirmModal, setErrorModal) => {
  return useMutation(handleBankAccount, {
    onSuccess: () => {
      setConfirmModal(true);
    },
    onError: () => {
      setErrorModal(true);
    },
  });
};

// ---------- ACCOUNT GET BVN -----------

const getBanks = async () => {
  const { data } = await clientApi.get(bankAccount);
  return data;
};

export const useGetUsersBanks = () => {
  return useQuery("users-bank", getBanks);
};

// ---------- DELETE CARD -----------

const handleDeleteCard = (bankId) => {
  return clientApi.delete(deleteCard(bankId));
};

export const useDeleteCard = (setConfirmModal, setErrorModal) => {
  const queryClient = useQueryClient();

  return useMutation(handleDeleteCard, {
    onSuccess: () => {
      setConfirmModal(true);
      queryClient.invalidateQueries("users-bank"); // When this mutation succeeds, invalidate any queries "fetch-single-post-by-id"
    },
    onError: () => {
      setErrorModal(true);
    },
  });
};

// export const deleteCards = async (postId) => {
//   // setLoading(true);
//   try {
//     // console.log("InterestService: GetAllInterests");
//     const response = await clientApi.delete(deleteCard(postId));
//     if (response.status === 200) {
//       console.log("DELETE response: ", response.data);
//       // setLoading(false);
//       return response.data;
//     }
//   } catch (error) {
//     // setLoading(false);
//     console.log(
//       "DELETE ERROR response: " + JSON.stringify(error.response.data)
//     );
//     // throw JSON.stringify(error.response.data.errors[0].errorMessages);
//   }
// };
